import announcement from './announcement';
import auth from './auth';
import broadcast from './broadcast';
import chain from './chain';
import clinicOrder from './clinic-order';
import configuration from './configuration';
import dashboard from './dashboard';
import exemption from './exemption';
import event from './event';
import location from './location';
import marketing from './marketing';
import medicine from './medicine';
import order from './order';
import organisation from './organisation';
import patient from './patient';
import pharmacy from './pharmacy';
import products from './products';
import serviceCatalog from './service-catalog';
import surgery from './surgery';
import user from './user';
import issues from './issues';
import signature from './signature';
import messages from './messages';
import clinic from './clinic';

const CoreAPI = {
  announcement,
  auth,
  broadcast,
  chain,
  clinicOrder,
  configuration,
  dashboard,
  exemption,
  event,
  location,
  marketing,
  medicine,
  order,
  organisation,
  patient,
  pharmacy,
  products,
  serviceCatalog,
  surgery,
  user,
  issues,
  signature,
  messages,
  clinic,
};

export default CoreAPI;
